import { App } from '@capacitor/app';
import Vue from 'vue';
import Router from 'vue-router';

//routes
import { DashboardRoute  } from 'Features/dashboard/router.js';
import { UserPreferencesRoute } from '../features/userPreferences/router';
import campaignEditRoute from 'Features/campaign/router.js';
import { BizgainOnboardingRoutes, BizgainOnboardingAppRoutes }  from 'Features/bizgainOnboarding/router';
import { HomeRoutes } from 'Features/home-mobile/routes';
import { PageNotFoundRoute } from './pageNotFound';
import { AuthenticationRoute } from 'Features/login/router.js';
import StoreSetupRoute from 'Features/storeSetup/router.js';
import AssetsRoute from 'Features/assets/router.js';
import PaymentRoutes from 'Features/wallet/router.js';
import { PublishedReportRoute } from 'Features/publishedReports/router.js';
import AppConfig from 'Constants/AppConfig';
import { InviteUserRoute } from 'Features/inviteUser/router'
import { UserEmailVerificationRoute } from 'Features/userEmailVerification/router';
import VueGtm from 'vue-gtm';
import RootLayout from 'Layouts/RootLayout'
import AppLayout from 'Layouts/AppLayout'
import { ForgotPasswordRoutes } from 'Features/forgotPassword/router';
import { LeadsRoute } from 'Features/leads/router';
import { SummaryRedirectRoute } from 'Features/summaryRedirect/router';

const appRoutes = [
  DashboardRoute,
  UserPreferencesRoute,
  campaignEditRoute,
  StoreSetupRoute,
  AssetsRoute,
  ...PaymentRoutes,
  PublishedReportRoute,
  UserEmailVerificationRoute,
  LeadsRoute
];

const rootLevelRoutes = [];

rootLevelRoutes.push(PageNotFoundRoute);

Vue.use(Router);

const router =  new Router({
  mode: process.env.VUE_APP_CORDOVA_BUILD ? 'hash' : 'history',
  routes: [
    {
      path: '/',
      component: RootLayout,
      redirect: '/login',
      props: (route) => ({ embed: String(route.query.embed).toLowerCase() === 'true' }),
      children: [
        ...BizgainOnboardingRoutes,
        ...BizgainOnboardingAppRoutes,
        {
          path: '/app/:businessProfileId',
          component: AppLayout,
          props: (route) => ({ embed: String(route.query.embed).toLowerCase() === 'true' }),
          children: appRoutes
        },
        AuthenticationRoute,
        InviteUserRoute,
        ...ForgotPasswordRoutes,
        ...HomeRoutes,
        SummaryRedirectRoute
      ]
    },
    {
      path: '/',
      component: RootLayout,
      children: rootLevelRoutes
    }
  ]
});

App.addListener('appUrlOpen', function (event) {
  // Example url: https://beerswift.app/tabs/tabs2
  // slug = /tabs/tabs2
  // TODO - need to fix for alternate domain / URL
  let url = new URL(event.url);
  let slug = url.pathname;
  // We only push to the route if there is a slug present
  if (slug) {
    router.push({
      path: slug
    });
  }
});

Vue.use(VueGtm, {
  vueRouter: router,
  id: AppConfig.gtmContainerId,
  enabled: process.env.VUE_APP_RELEASE_STAGE === 'production'
})

export default router;